/**
 * @file 风险提示弹窗
 */
import { useEffect, useRef } from 'react';
import { Modal, Checkbox, Button } from '@bfe/moly';
import { useFm } from '@web3/base-hooks';
import { useParams } from '@web3/base-hooks';
import { scTrack } from '@web3/base-tracking';
import { Event, Page } from '@/config/track-config';
import { usePoolInfoContext } from '@/hooks/usePoolInfo';

import styles from './index.module.scss';

interface Props {
  show: boolean;
  onConfirm: (v: boolean) => void;
  onClose: () => void;
}

export const DisclaimeModal = (props: Props) => {
  const { show, onConfirm, onClose } = props;
  const fm = useFm();
  const { locale } = useParams();
  const { poolInfo } = usePoolInfoContext();
  const checkedRef = useRef(false);

  const onCheckedChange = (e: Event, checked: boolean) => {
    if (checked) {
      scTrack(Event.Web3UserClick, {
        page_name: Page.Disclaimer,
        spmName: poolInfo.poolName,
        button_name: 'disclaimer_ikonw',
      });
    }
    checkedRef.current = checked;
  };

  useEffect(() => {
    scTrack(Event.Web3PageView, {
      page_name: Page.Disclaimer,
      spmName: poolInfo.poolName,
    });
  }, []);

  return (
    <Modal
      open={show}
      onClose={() => {
        scTrack(Event.Web3UserClick, {
          page_name: Page.Disclaimer,
          spmName: poolInfo.poolName,
          button_name: 'disclaimer_close',
        });
        onClose();
      }}
      title={fm('disclaimer')}
      width={480}
      footer={null}
      modal={false}
    >
      <div className={styles.content}>
        <span className={styles.disclaimerText}>
          {fm('thirdPartyServiceDisclaimer')}
        </span>
        <span
          className={styles.disclaimerExtraText}
          onClick={() => {
            if (window.top) {
              window.top.open(
                `/${locale}/help-center/article/Agreement-for-Web3-Earn`
              );
            }
          }}
        >{` <${fm('bybitWeb3EarnTerms')}>`}</span>
      </div>
      <Checkbox
        className={styles.checkbox}
        onChange={onCheckedChange}
        size="small"
      >
        {fm('noMoreRemindersInfo')}
      </Checkbox>
      <Button
        variant="primary"
        className={styles.button}
        onClick={() => {
          onClose();
          scTrack(Event.Web3UserClick, {
            page_name: Page.Disclaimer,
            spmName: poolInfo.poolName,
            button_name: 'disclaimer_ikonw',
          });
          onConfirm(checkedRef.current);
        }}
      >
        {fm('gotIt')}
      </Button>
    </Modal>
  );
};
